import { slug as slugify } from '@magalu/mixer-utils';
export var suggestionLinkClick = function suggestionLinkClick(link) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'magalu-has',
    eventLabel: "".concat(slugify(link.value).toLowerCase())
  };
};